// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__2ZDn4","name":"ConsentHeader_name__3zLtN","birthday":"ConsentHeader_birthday__2bPMV","skeleton":"ConsentHeader_skeleton__3lGWb"};